import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import Modal from "react-modal";
import styled from "styled-components";
import NumberPad from "../../components/NumberPad";
import Toggle from "../../components/Toggle";
import { langState, langText } from "../../recoil/lang";
import { useRecoilState, useRecoilValue } from "recoil";
import { PG_METHOD } from "../../controller/OrderController";

type Props = {
  isVisible: { visible: boolean; method: number; card_name?: string };
  setVisible: (bVisible: {
    visible: boolean;
    method: number;
    card_name?: string;
  }) => void;
  doPayment: any;
  isVoucher: boolean;
};

const CustomerInfoModal = ({
  isVisible,
  setVisible,
  doPayment,
  isVoucher,
}: Props) => {
  const lang = useRecoilValue<number>(langState);
  const [numberTemp, setNumberTemp] = useState<string>("");
  const [emailTemp, setEmailTemp] = useState<string>("");

  const [toggleOn, setToggleOn] = useState(true);

  const onClose = () => {
    setVisible({ visible: false, method: PG_METHOD });
  };

  const changeNumber = (e: any) => {
    if (e.length <= 8) {
      setNumberTemp(e);
    }
  };

  const changeEmail = (e: any) => {
    setEmailTemp(e.target.value);
  };

  const formatPhoneNumberWithColor = (number: string) => {
    const paddedNumber = number.padEnd(8, "0");

    const firstPart = paddedNumber.slice(0, 4);
    const secondPart = paddedNumber.slice(4, 8);

    const renderColoredPart = (part: string, enteredCount: number) => {
      return part.split("").map((digit, index) => {
        const isEntered = index < enteredCount;
        return (
          <span key={index} style={{ color: isEntered ? "#fff" : "#737373" }}>
            {digit}
          </span>
        );
      });
    };

    const enteredDigitsCount = number.length;
    const hyphenColor = enteredDigitsCount >= 4 ? "#fff" : "#737373";

    return (
      <>
        <span>010-</span>
        {renderColoredPart(firstPart, Math.min(enteredDigitsCount, 4))}
        <span style={{ color: hyphenColor }}>-</span>
        {renderColoredPart(secondPart, Math.max(0, enteredDigitsCount - 4))}
      </>
    );
  };

  const goPayment = () => {
    console.log("number", numberTemp, "email", emailTemp);
    if (
      (toggleOn && numberTemp.length === 8) ||
      (!toggleOn && emailTemp.length > 5)
    ) {
      if (toggleOn) {
        doPayment(
          isVisible.method,
          "010" + numberTemp,
          undefined,
          isVisible.card_name
        );
      } else {
        doPayment(isVisible.method, undefined, emailTemp, isVisible.card_name);
      }
    }
  };

  useEffect(() => {
    setToggleOn(true);
    if (!isVisible) {
      setNumberTemp("");
      setEmailTemp("");
    }
  }, [isVisible]);
  useEffect(() => {
    setNumberTemp("");
    setEmailTemp("");
  }, [toggleOn]);

  return (
    <Modal
      isOpen={isVisible.visible}
      onRequestClose={onClose}
      className="customerInfoModal modal-content"
      closeTimeoutMS={100}
    >
      <Style>
        <div className="modalWrapper">
          <img
            className="closeIcon"
            onClick={onClose}
            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_arrow_left.svg`}
            alt="back"
          />
          <div className="modalContent">
            <div className="title">
              {isVoucher ? (
                <h2>{langText.coupon_contact_request[lang]}</h2>
              ) : (
                <>
                  <h2>{langText.customer_info_modal_title[lang]}</h2>
                  <p>*{langText.customer_info_notice[lang]}</p>
                </>
              )}
            </div>
            <div className="customerTypeWrap">
              <Toggle
                toggleOn={toggleOn}
                setToggleOn={setToggleOn}
                toggle1={
                  <>
                    <img
                      src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_kakao${
                        toggleOn ? "_active" : ""
                      }.svg`}
                      alt="카카오톡 아이콘"
                    />
                    {langText.customer_info_modal_kakao[lang]}
                  </>
                }
                toggle2={
                  <>
                    <img
                      src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_email${
                        !toggleOn ? "_active" : ""
                      }.svg`}
                      alt="카카오톡 아이콘"
                    />
                    E-MAIL
                  </>
                }
              />
            </div>
            <div className="customerInfoWrap">
              {toggleOn ? (
                <div className="phoneWrap">
                  <h1>{formatPhoneNumberWithColor(numberTemp)}</h1>
                  <NumberPad number={numberTemp} setNumber={changeNumber} />
                </div>
              ) : (
                <div className="emailWrap">
                  <input
                    value={emailTemp}
                    onChange={(e) => changeEmail(e)}
                    type="text"
                    placeholder="Please enter your e-mail"
                  />
                </div>
              )}
            </div>
          </div>
          <div className="modalFooter">
            <button onClick={goPayment}>{langText.button_confirm[lang]}</button>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default CustomerInfoModal;

const Style = styled.div`
  h1,
  h2,
  h3,
  h4,
  p {
    padding: 0;
    margin: 0;
  }

  /* modalWrapper */
  .modalWrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    padding: 8dvh 0 4dvh 0;
    min-height: 100dvh;
    background: #343434;
  }
  .closeIcon {
    position: absolute;
    top: 13px;
    left: 4px;
    cursor: pointer;
  }

  .modalContent {
    flex: 1;
  }

  .title {
    padding: 0 3vw;
    h2 {
      font-size: 16px;
      line-height: 22px;
      font-weight: 500;
      color: #fff;
      text-align: center;
      white-space: pre-line;
    }
    p {
      padding-top: 10px;
      font-size: 10px;
      line-height: 14px;
      text-align: center;
      color: #ff4a4a;
    }
  }

  /* customerTypeWrap */
  .customerTypeWrap {
    width: 80%;
    margin: 0 auto;
    margin-top: 20px;
    .toggleWrap {
      width: 100%;
      button {
        min-width: 140px;
        padding: 10px 0;
        font-size: 18px;
        gap: 8px;
      }
      img {
        width: 22px;
      }
    }
  }
  /* customerInfoWrap */
  .customerInfoWrap {
    text-align: center;
    h1 {
      margin: 3dvh 0;
    }
    span {
      font-size: 28px;
      font-weight: 600;
    }
    .emailWrap {
      margin: 30px 0;

      input {
        width: 80%;
        padding: 10px;
        text-align: center;
        background: none;
        border: 2px solid #cecece;
        font-size: 24px;
        font-weight: 600;
        color: #fff;
        border-radius: 10px;
      }
      input::placeholder {
        color: #737373;
      }
    }
  }

  /* numberPadWrap */
  .numberPadWrap {
    padding: 10px 0;
    background: #232323;
  }

  /* modalFooter */
  .modalFooter {
    padding: 16px 30px 0 30px;
    button {
      width: 100%;
      padding: 14px 0;
      background: #4dd2ae;
      border-radius: 10px;
      font-size: 20px;
      font-weight: 600;
      color: #fff;
    }
  }
`;
